/* src/app/app.component.scss */
html,
body {
  min-height: 100%;
  height: 100%;
}
.container {
  z-index: 1;
  width: 100%;
  min-height: calc(100vh - 100px);
}
/*# sourceMappingURL=app.component.css.map */
